import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { notificationsPreferencesBackend } from './notifications-preferences.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { notificationsPreferencesReducer } from './notifications-preferences.reducer';

// FIXME: remove that
backend.notificationsPreferences = notificationsPreferencesBackend;

@NgModule({
  imports: [
    StoreModule.forFeature(
      'notificationsPreferences',
      notificationsPreferencesReducer,
    ),
    /* DatastoreBackendModule.forFeature(
      'notificationsPreferences',
      notificationsPreferencesBackend,
    ),*/
  ],
})
export class DatastoreNotificationsPreferencesModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/notifications-preferences/notifications-preferences.module.ts